import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatterMortgageWithAssociations } from '@models/mortgage';

@Component({
	selector: 'app-closer-sync-terms',
	templateUrl: './closer-sync-terms.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncTermsComponent {
	public _mortgage: MatterMortgageWithAssociations;
	@Input() set mortgage(mortgage: MatterMortgageWithAssociations) {
		this._mortgage = mortgage;
	}
}
